import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createArtist } from "../api/artistsApi";
import { queryKeys } from "../lib/queryKeys";

export function useCreateArtist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createArtist,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.artists.all });
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
    },
  });
}
